module.exports = __webpack_public_path__ + "img/IMG_6996.88edac76.webp";